<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-container-single element-non-bodymatter element-type-epigraph element-without-heading" id="epigraph">
<div class="text" id="epigraph-text">
<div class="alignment-block alignment-block-align-center">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center"><i>“It is not in the stars to hold our destiny but in ourselves.”</i></p>
<p class="alignment-block-content alignment-block-content-center"><i>― William Shakespeare</i></p>
</div>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?39f15e40